export const phoneRegExp = /^[+][(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im;
export const timeRegExp = /^(0[1-9]|1[0-2]):[0-5][0-9] (AM|PM)$/;
export const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?)/i;

